// Facade module: importing every generator triggers its self-registration side
// effect (MaskGenerator.register pushes onto interface.generators), then we
// re-export that shared registry array.
import * as util from "./util.js";
import * as cconst from "./const.js";
import "./sample_removal.js";
import "./darts.js";
import "./sph.js";
import "./void_cluster.js";
import "./fft.js";
import "./darts2.js";
import "./mitchell.js";
import "./mask_optimize.js";
import "./blue_voidcluster.js";
import "./smoothedmask.js";
import "./void_cluster_cmyk.js";
import "./TileOpt.js";
import * as sinterface from "./interface.js";

export const generators = sinterface.generators;
